import { http } from 'src/utils/http.util'
import { TChatbotApiPayload } from 'src/pages/configuration/followups/[followupId]/chatbot/_components/chatbot-general-form/chatbot.helper'
import type {
  TUpdateChatbotPayload,
  TChatbotResponse,
} from 'src/pages/configuration/followups/[followupId]/chatbot/_components/chatbot-general-form/chatbot-api.type'

export const ChatbotService = {
  create: async (projectId: number, followupId: number, payload: TChatbotApiPayload): Promise<any> => {
    const res = await http.post(
      `/projects/${projectId}/self-configuration/followups/${followupId}/chatbots`,
      payload,
    )
    return res.data
  },

  get: (projectId: number, followupId: number, chatbotId: number): Promise<TChatbotResponse> => {
    return http
      .get(`/projects/${projectId}/self-configuration/followups/${followupId}/chatbots/${chatbotId}`)
      .then((res) => res.data)
  },

  update: async (
    projectId: number,
    followupId: number,
    chatbotId: number,
    payload: TUpdateChatbotPayload,
  ): Promise<any> => {
    const res = await http.put(
      `/projects/${projectId}/self-configuration/followups/${followupId}/chatbots/${chatbotId}`,
      payload,
    )
    return res.data
  },

  delete: (projectId: number, followupId: number, chatbotId: number): Promise<void> => {
    return http
      .delete(`/projects/${projectId}/self-configuration/followups/${followupId}/chatbots/${chatbotId}`)
      .then((res) => res.data)
  },

  publish: async (
    projectId: number,
    followupId: number,
    chatbotId: number,
    isActive: boolean,
  ): Promise<TChatbotResponse> => {
    const res = await http.put(
      `/projects/${projectId}/self-configuration/followups/${followupId}/chatbots/${chatbotId}/publish`,
      { isActive },
    )
    return res.data
  },

  clone: (
    projectId: number,
    followupId: number,
    chatbotId: number,
    payload: { targetProjectId: number; targetFollowupId: number; medeventListIds?: number[] },
  ): Promise<{
    id: number
    targetProjectId: number
    targetFollowupId: number
  }> => {
    return http
      .post(
        `/projects/${projectId}/self-configuration/followups/${followupId}/chatbots/${chatbotId}/clone`,
        payload,
      )
      .then((res) => res.data)
  },
}
